import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'lib/store';
import { ProgressBar } from 'types/navigation';

export interface NavigationSettings {
  userInJourney?: boolean;
  viewedContent: string[];
  progress: ProgressBar;
}

export const initialState: NavigationSettings = {
  userInJourney: false,
  viewedContent: [],
  progress: {
    first: 0,
    second: 0,
    third: 0,
    label: 'Get Started',
    step: 1,
  },
};

const navigationSlice = createSlice({
  initialState,
  name: 'navigation',
  reducers: {
    setUserInJourney: (
      state,
      action: PayloadAction<NavigationSettings['userInJourney']>
    ) => {
      return {
        ...state,
        userInJourney: action.payload,
      };
    },
    setViewedContent: (state, action) => {
      return {
        ...state,
        viewedContent: action.payload,
      };
    },
    setProgress: (
      state,
      action: PayloadAction<NavigationSettings['progress']>
    ) => {
      return {
        ...state,
        progress: action.payload,
      };
    },
  },
});

const { actions, reducer } = navigationSlice;

export const { setUserInJourney, setViewedContent, setProgress } = actions;

export const selectProgress = (state: RootState) => state.navigation.progress;

export default reducer;
